import React, { useState } from "react";
import Chevron from "../../../assets/images/common/chevron-right.svg";
import "../../../assets/css/laboratory/bloodtest/bloodtest.scss";
import AddTestModal from "../../../components/laboratory/bloodtest/AddTestModal";
import LaboratoryWrapper from "../../../components/common/LaboratoryWrapper";
import xrayIcon from "../../../assets/images/laboratory/xray/xray.svg";

const BloodTest = () => {
  const rows = [
    {
      testname: "ABSOLUTE EOSINO",

      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",

      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",

      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",

      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",

      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",

      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",

      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      testdepartment: "Haematology",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",

      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",

      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",

      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",

      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      rate: "KWD 255.00",
    },
    {
      testname: "ABSOLUTE EOSINO",
      rate: "KWD 255.00",
    },
  ];
  const [showAddTestModal, setshowAddTestModal] = useState(false);

  const handleAddTestModal = () => {
    setshowAddTestModal(true);
  };

  return (
    <>
      <AddTestModal
        xrays="xrays"
        bloodTest="bloodTest"
        open={showAddTestModal}
        onClose={() => setshowAddTestModal(false)}
      />

      <div className="row px-3 mb-lg-5 mb-4  pb-5 pt-4 bloodtest-tab">
        <div className="col-12">
          <p className="mb-0 bloodtest-heading">Blood Test</p>
        </div>

        <div className="col-12 my-4">
          <div className="row ">
            <div className="col-md-6 ">
              <p className="bloodtest-breadcrumb">
                <span>DASHBOARD</span>
                <img src={Chevron} />
                <span> LABORATORY </span>
                <img src={Chevron} />
                <span className="current-tab"> X-RAYS</span>
              </p>
            </div>
            <div class="col-md-6 text-md-right ">
              <button
                type="button"
                class="add-test"
                onClick={handleAddTestModal}
              >
                Add Test
              </button>
            </div>
          </div>
        </div>

        <LaboratoryWrapper
          title="X-Rays Details"
          requestSectionTitle="X-Rays Request"
          rows={rows}
          icon={xrayIcon}
        />
      </div>
    </>
  );
};

export default BloodTest;
